import { useSearchParams } from "react-router-dom";

const useQueryParams = (key) => {
  let [searchParams, setSearchParams] = useSearchParams();
  return { search: searchParams.get(key || "search"), setSearchParams };
};

export default useQueryParams;

// useSearchParams hook is used to read and modify the query string in the URL for the current location.
